module.exports = __webpack_public_path__ + "static/img/15.a1860f83.png";